/**
 * O que a sessao alcanca, para a interface esconder o resto (spec 0009).
 *
 * Repetindo porque e a confusao que custa caro: **isto nao autoriza nada**. Cada rota do backend
 * checa por conta propria, e uma requisicao direta, sem passar pela tela, para la do mesmo jeito.
 * O que este modulo evita e oferecer um botao que vai responder 403 - frustracao, nao brecha.
 *
 * Enquanto os resources de modulo nao existirem no Auth, o backend responde
 * `module_permissions_enforced: false` e "pode tudo", que e o comportamento de hoje. A tela nao
 * precisa saber em qual regime esta: pergunta a mesma coisa nos dois.
 */

import { useQuery } from '@tanstack/react-query'

import { fetchPermissoes } from './api'

export function usePermissoes() {
  const consulta = useQuery({
    queryKey: ['permissions'],
    queryFn: fetchPermissoes,
    retry: false,
    // A permissao muda no Auth, por fora deste app. Meia hora e o mesmo intervalo do snapshot:
    // tempo de uma sessao de trabalho sem reconsultar a cada troca de tela.
    staleTime: 30 * 60 * 1000,
  })

  /**
   * VISIBILIDADE degrada para "mostra", nao para "esconde" - e a direcao oposta da autorizacao, de
   * proposito.
   *
   * Se esta consulta falhar (backend antigo sem a rota, Auth fora do ar, rede), esconder tudo
   * deixaria a tela vazia para quem TEM acesso, sem explicar nada. Mostrar e seguro porque quem
   * recusa e a rota: o clique volta 403 com a frase certa. O custo de falhar aberto aqui e um
   * botao que da erro; o de falhar fechado e um app que parece quebrado.
   *
   * Resposta que CHEGOU e disse "nao" e respeitada - isso nao e falha, e a resposta.
   */
  function pode(resource: string, acao: 'read' | 'manage'): boolean {
    if (consulta.error !== null) return true
    const capacidade = consulta.data?.modules[resource]
    if (capacidade === undefined) return false
    return acao === 'manage' ? capacidade.manage : capacidade.read
  }

  return {
    pode,
    carregando: consulta.isPending,
    erro: consulta.error,
    aplicado: consulta.data?.module_permissions_enforced ?? false,
  }
}
